import type { DependencyList, EffectCallback } from "react";
import { useEffect, useRef } from "react";

/**
 * `useEffect` wrapper that does not run the effect on the initial mount, only subsequent renders.
 *
 * @param effect - The effect to run on subsequent renders.
 * @param deps - An array of dependencies to watch for changes.
 */
export const useUpdateEffect = (effect: EffectCallback, deps: DependencyList) => {
  const isInitialMountRef = useRef<boolean>(true);

  useEffect(() => {
    if (isInitialMountRef.current) {
      isInitialMountRef.current = false;
      return;
    }

    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
